import Select from "react-select";
import AsyncSelect from "react-select/async";

const SelectDropDown = ({
  label,
  selectedOption,
  handleChange,
  options,
  loadOptions,
  placeholder = "Type 3+ letters",
  isSearchable = false,
  disabled = false,
  styles,
  ...props
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#9ca3af" : "#d1d5db",
      boxShadow: "none",
      borderRadius: "0.375rem",
      "&:hover": {
        borderColor: "#9ca3af",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#777",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#000",
    }),
  };


  return (
    <div>
      {label && (
        <label className="block text-md ml-3 text-[#242424]">{label}</label>
      )}
      {isSearchable ? (
        <AsyncSelect
          cacheOptions
          defaultOptions
          loadOptions={loadOptions}
          value={selectedOption || null}
          onChange={handleChange}
          placeholder={placeholder}
          isDisabled={disabled}
          styles={{ ...customStyles, ...styles }}
          className="text-black custom-focus-reset border rounded-md"
          {...props}
        />
      ) : (
        // <Select
        //   options={options || []}
        //   value={selectedOption || null}
        //   onChange={handleChange}
        //   // placeholder={placeholder}
        //   isDisabled={disabled}
        //   // styles={{ ...customStyles, ...styles }}
        //   // className="text-black custom-focus-reset border rounded-md"
        //   className="basic-single"
        //   classNamePrefix="select"
        //   name="undefined"
        //   isSearchable={false}
        //   {...props}
        // />

        <Select
          className="basic-single"
          classNamePrefix="select"
          isDisabled={disabled}
          onChange={handleChange}
          name="color"
          options={options || []}
          {...props}
        />
      )}
    </div>
  );
};

export default SelectDropDown;
